import React, { useState, useEffect } from 'react'
import { MDBInput } from 'mdbreact';

const FacturaElectronica = ({ clienteRegis, checkFac, cambiarCheckFac }) => {
    return (
        <React.Fragment>
            <div className="domicilios">
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ flex: 2 }}>
                        <MDBInput
                            onClick={e => cambiarCheckFac(e.target.checked)}
                            checked={checkFac}
                            style={{ marginTop: "15px" }}
                            type="checkbox"
                            id="fact"
                        />
                    </div>
                    <div style={{ flex: 10 }}>
                        <label htmlFor='fact' className="labelPasare"> ¿Desea enviar factura por email?</label>
                    </div>
                </div>
            </div>
            {checkFac ?
                <div className="row domicilios">
                    <div className='col-md-12'>
                        <span>
                            <b>Nombres: </b>{clienteRegis?.nombres}
                            <br />
                        </span>
                        <span><b>Email:</b> {clienteRegis?.email}</span>
                    </div>

                </div>
                : null}
        </React.Fragment>
    )
}

export default FacturaElectronica